import React, { useState } from "react";
import { Link } from "react-scroll";

function Header() {
  const menuItems = [
    {
      id: 1,
      title: "Home",
      anchor: "main",
    },
    {
      id: 2,
      title: "Implementation",
      anchor: "Implementation",
    },
    {
      id: 3,
      title: "Videos",
      anchor: "Videos",
    },
    {
      id: 4,
      title: "About the project",
      anchor: "About",
    },
  ];
  const [navbar, setNavbar] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= 100) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener("scroll", changeBackground);

  return (
    <header>
      <nav className={navbar ? "navbar active" : "navbar"}>
        <h2 className="top">
          <Link
            to="main"
            smooth={true}
            offset={-400}
            duration={500}
            spyThrottle={500}
          >
            Immersive <span style={{ color: "red" }}>Raphael</span> Project
          </Link>
        </h2>

        <ul>
          {menuItems.map((menu) => (
            <li className="nav-item">
              <Link
                to={menu.anchor}
                spy={true}
                smooth={true}
                offset={-100}
                duration={500}
              >
                {menu.title}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
}
export default Header;
